import { Component, h } from 'preact';
import linkState from 'linkstate';

import { Inquiry } from '../../../../../types/inquiries';
import { HopplerModalizer } from '../../common/hoppler-modalizer.component';
import { FormattedNumberInput } from '../../common/formatted-number-input.component';
import { inquiryService } from '../../../../utils/inquiry.service';
import { ReqState } from '../../../../../types';


interface InqEditCollectionAmountModalProps {
  inquiry: Inquiry;
  onClose: () => void;
  onAmountUpdateSuccess: () => void;
}

interface InqEditCollectionAmountModalState {
  newAmount?: number;
  reqState?: ReqState;
}

export class InqEditCollectionAmountModal extends Component<InqEditCollectionAmountModalProps, InqEditCollectionAmountModalState> {
  constructor(props: InqEditCollectionAmountModalProps) {
    super(props);

    this.state = {
      newAmount: props.inquiry.totalAmount
    };
  }

  async onSubmit(event: Event) {
    event.preventDefault();

    const inquiry = this.props.inquiry;

    try {
      this.setState({ reqState: ReqState.IN_PROGRESS });
      const response = await inquiryService.updateCollectionAmount(inquiry.inquiryCode, this.state.newAmount);
      this.setState({ reqState: ReqState.SUCCESS });

      this.props.onClose();
      this.props.onAmountUpdateSuccess();
    } catch (err) {
      this.setState({ reqState: ReqState.FAILED });
      console.error(err);
    }
  }

  isSubmitButtonEnabled() {
    return !!this.state.newAmount;
  }

  getSubmitButton() {
    if (this.state.reqState === ReqState.IN_PROGRESS) {
      return (
        <button className="btn btn-secondary" disabled>
          <i className="fas fa-cog fa-spin" /> Submitting...
        </button>
      )
    } else {
      return (
        <button type="submit" className="btn btn-secondary">
          Submit
        </button>
      );
    }
  }

  render(props: InqEditCollectionAmountModalProps, state: InqEditCollectionAmountModalState) {
    return (
      <HopplerModalizer onClose={ () => null}>
        <div className="hi-edcolamtmod">
          <div className="hi-edcolamtmod__title-bar">
            <span className="hi-edcolamtmod__title-label">Edit Collection Amount</span>
            <button className="btn btn-link hi-edcolamtmod__title-close" onClick={ props.onClose }>
              <i className="fas fa-times" /> close
            </button>
          </div>

          <div className="hi-edcolamtmod__body">
            <form className="hi-edcolamtmod__content" onSubmit={ evt => this.onSubmit(evt) }>
              <div className="hi-input-group">
                <label className="hi-input-group__label">
                  New Amount
                </label>
                <FormattedNumberInput className='form-control'
                  placeholder='PHP' prefix='PHP '
                  value={ state.newAmount }
                  onChange={ linkState(this, 'newAmount') } />
              </div>

              <div className="text-center">
                { this.getSubmitButton() }
              </div>
            </form>
          </div>
        </div>
      </HopplerModalizer>
    );
  }
}
